import React from "react";
import { FormSection, FormFieldGroup } from "component-library/formSections";
import Table from "./earnings-table/Table";
import * as Fields from "../FieldNames";

const ScheduledDeductions = ({ data = {}, onChange }) => {
  return (
    <FormSection title={"Scheduled Deductions"} hr>
      <FormFieldGroup
        inputType="radio"
        inputName={Fields.changeScheduledDeductions}
        label="Do you want to make any changes to the employee's scheduled deductions ?"
        fieldType="inline"
        value={data[Fields.changeScheduledDeductions]}
        radios={[
          { id: 1, value: true, label: "Yes" },
          { id: 2, value: false, label: "No" }
        ]}
        class="col-lg-12"
        colSpan="col-lg-3 col-md-3"
        Size={[6, 4, 12, 12]}
        onChange={onChange}
      />
      {data[Fields.changeScheduledDeductions] && (
        <Table entity="deductions" data={data} onChange={onChange} />
      )}
    </FormSection>
  );
};

export default ScheduledDeductions;
